import * as remote from './remotes';
import * as stub from './stubs';
import { endpoints } from './endpoints';
import { GetMembershipDetails, RequestCard, GetWallet } from './contracts';

type Sources = {
  getMembershipDetails: GetMembershipDetails;
  requestCard: RequestCard;
  getAppleWallet: GetWallet;
  getAndroidWallet: GetWallet;
};

const stubs: Sources = {
  getMembershipDetails: stub.GetMembershipDetailsStub,
  requestCard: stub.RequestCardStub,
  getAppleWallet: stub.GetAppleWalletStub,
  getAndroidWallet: stub.GetAndroidWalletStub,
};

const remotes: Sources = {
  getMembershipDetails: remote.GetMembershipDetailsApi(endpoints.getMembershipDetails),
  requestCard: remote.RequestCardApi(endpoints.requestCard),
  getAppleWallet: remote.GetAppleWalletApi(endpoints.getAppleWallet),
  getAndroidWallet: remote.GetAndroidWalletApi(endpoints.getAndroidWallet),
};

export const useRemote =
  process.env.NODE_ENV === 'production' || process.env.REACT_APP_SOURCES === 'remote' ? true : false;

export const sources = useRemote ? remotes : stubs;
